import { AgGridAngular, ICellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, GridOptions, ICellRendererParams } from 'ag-grid-community';
import { Component, ViewChild } from '@angular/core';
import { UserProfileSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  RowDetalheItemGuia,
  RowItemCriticasItem,
  RowItemDetalhePacote,
  RowItemMotivosRejeicao,
} from '../../detalhes-guia.component';
import { buildGridOptions } from '@gestor-web/app/shared/components';

const COLUMNS_DETALHE_PACOTE: ColDef[] = [
  {
    headerName: 'Nr. registro pacote',
    field: 'nr_registro_pacote',
    type: 'int',
  },
  {
    headerName: '077-Tabela TUSS do item',
    field: 'cd_tabela_tuss',
    type: 'str',
  },
  {
    headerName: '078-Cód. procedimento',
    field: 'cd_proced_item',
    type: 'str',
  },
  {
    headerName: '079-Qtd. paga de itens do pacote',
    field: 'qt_pago_pacote',
    type: 'int',
  },
  {
    headerName: 'Qtde. paga acumulado no pacote',
    field: 'qt_pago_pacote_acumulado',
    type: 'int',
    width: 160,
  },
  {
    headerName: '129-Unidade de medida itens assistenciais',
    field: 'nm_cd_unidade_medida',
    width: 200,
  },
  {
    headerName: 'Procedimento item',
    field: 'nm_proced_item',
  },
  {
    headerName: 'Forma de envio',
    field: 'nm_id_forma_envio',
  },
  {
    headerName: 'Classe',
    field: 'sg_classe',
    type: 'int',
  },
];

const COLUMNS_CRITICAS_ITEM: ColDef[] = [
  {
    headerName: 'Cód. crítica',
    field: 'cd_critica',
  },
  {
    headerName: 'Bloco info',
    field: 'ds_bloco_info',
  },
  {
    headerName: 'Nome campo',
    field: 'nm_campo_ans',
  },
  {
    headerName: 'Descrição',
    field: 'ds_critica',
    width: 400,
    wrapText: true,
    autoHeight: true,
  },
  {
    headerName: 'Tipo crítica',
    field: 'nm_tp_critica',
  },
  {
    headerName: 'Tipo impacto',
    field: 'nm_tp_impacto',
  },
];

const COLUMNS_MOTIVOS_REJEICAO: ColDef[] = [
  {
    headerName: 'Campo',
    field: 'campo',
    width: 300,
  },
  {
    headerName: 'Motivos de rejeição',
    field: 'motivo_rejeicao',
    width: 500,
    wrapText: true,
    autoHeight: true,
  },
];

@Component({
    selector: 'bl-guia-item-detalhe-cell',
    templateUrl: './item-detalhe-cell.component.html',
    styleUrls: ['./item-detalhe-cell.component.scss'],
    standalone: false
})
export class ItemDetalheCellRenderer implements ICellRendererAngularComp {
  @ViewChild('agGridDetalhePacote') agGridDetalhePacote: AgGridAngular<RowItemDetalhePacote>;
  @ViewChild('agGridCriticasItem') agGridCriticasItem: AgGridAngular<RowItemCriticasItem>;
  @ViewChild('agGridMotivosRejeicao') agGridMotivosRejeicao: AgGridAngular<RowItemMotivosRejeicao>;

  gridOptionsDetalhePacote: GridOptions<RowItemDetalhePacote>;
  gridOptionsCriticasItem: GridOptions<RowItemCriticasItem>;
  gridOptionsMotivosRejeicao: GridOptions<RowItemMotivosRejeicao>;

  params: ICellRendererParams<RowDetalheItemGuia>;
  data: RowDetalheItemGuia;

  isAdmin = false;

  constructor(private store: Store) {}

  agInit(params: ICellRendererParams<RowDetalheItemGuia>): void {
    this.store
      .select(UserProfileSelectors.selectIsAdmin)
      .pipe(takeUntil(this.ngDestroyed$))
      .subscribe(isAdmin => {
        this.isAdmin = isAdmin;
        this.configureGrids();
      });

    this.updateValue(params);
  }

  refresh(params: ICellRendererParams<RowDetalheItemGuia>) {
    this.updateValue(params);
    return true;
  }

  updateValue(params: ICellRendererParams<RowDetalheItemGuia>) {
    this.params = params;
    this.data = params.data;
  }

  configureGrids() {
    const filteredColumns =
      this.isAdmin ? COLUMNS_DETALHE_PACOTE : COLUMNS_DETALHE_PACOTE.filter(col => col.field != 'sg_classe');

    this.gridOptionsDetalhePacote = buildGridOptions<RowItemDetalhePacote>(
      {
        columnDefs: filteredColumns,
      },
      {
        sideBar: null,
        statusBar: null,
      },
    );
    this.gridOptionsCriticasItem = buildGridOptions<RowItemCriticasItem>(
      {
        columnDefs: COLUMNS_CRITICAS_ITEM,
      },
      {
        sideBar: null,
        statusBar: null,
        grandTotalRow: null,
      },
    );
    this.gridOptionsMotivosRejeicao = buildGridOptions<RowItemMotivosRejeicao>(
      {
        columnDefs: COLUMNS_MOTIVOS_REJEICAO,
      },
      {
        sideBar: null,
        statusBar: null,
        grandTotalRow: null,
      },
    );
  }

  private ngDestroyed$ = new Subject<void>();
  ngOnDestroy() {
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  }
}
